<template>
    <div class="register">
        <div class="wrapper">
            <div class="wrapper-logo"><img src="../../assets/img/logo.png"/></div>
            <div class="container">
                <ul class="formNav">
                    <li @click="formNavEvent(0)" :class="formNavIndex===0 ? 'nav-active' : '' ">验证码注册</li>
                    <li @click="formNavEvent(1)" :class="formNavIndex===1 ? 'nav-active' : '' ">密码注册</li>
                </ul>
                <div class="form-item-wrap">
                    <dl class="form-item-label">
                        <img class="phone-icon" src="../../assets/img/icon/phone.png"/>
                        <span>手机号</span>
                    </dl>
                    <dl class="form-item-input">
                        <input type="text" placeholder="请输入手机号码" v-model="mobile"/>
                    </dl>
                    <dl class="form-item-label">
                        <img class="verify-icon" src="../../assets/img/icon/yanzheng.png"/>
                        <span>图形验证码</span>
                    </dl>
                    <dl class="form-item-input">
                        <input type="text" placeholder="请输入图形验证码" v-model="vertification"/>
                        <img :src="ImgCodeSrc" class="code-img" @click="getImgCode"/>
                    </dl>
                    <!--  验证码注册 -->
                    <div>
                        <dl class="form-item-label">
                            <img class="verify-icon" src="../../assets/img/icon/yanzheng.png"/>
                            <span>验证码</span>
                        </dl>
                        <dl class="form-item-input">
                            <input type="text" placeholder="请输入验证码" v-model="code"/>
                            <span class="code-btn" id="getCodeBtn" :disabled="codeFlag" @click="getCode">获取验证码</span>
                        </dl>
                    </div>
                    <!-- 密码注册 -->
                    <div v-show="formNavIndex===1">
                        <dl class="form-item-label">
                            <img class="verify-icon" src="../../assets/img/icon/pwd.png"/>
                            <span>密码设置</span>
                        </dl>
                        <dl class="form-item-input">
                            <input type="password" placeholder="请输入登录密码" v-model="password"/>
                        </dl>
                    </div>
                    <dl class="form-item-label">
                        <img class="verify-icon" src="../../assets/img/icon/yanzheng.png"/>
                        <span>邀请码</span>
                    </dl>
                    <dl class="form-item-input">
                        <input type="text" placeholder="请输入邀请码" v-model="pid" :disabled="hasPid"/>
                    </dl>
                    <dl class="form-item-extract"><span @click="$router.push('/login')">账号登录</span></dl>
                    <button class="form-item-btn" @click="onRegister">确定</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                mobile: '',
                ImgCodeSrc: '',
                vertification: '',
                captchaToken: '',
                codeFlag: false,
                pid: '',
                code: '',
                password: "",
                hasPid: false,
                formNavIndex: 0
            }
        },
        created() {
            this.getImgCode();
            console.log(this.$route.query.code);
            this.pid = this.$route.query.code;
            if (this.pid) {
                this.hasPid = true;
            }
        },
        methods: {
            formNavEvent(index) {
                this.formNavIndex = index;
                this.mobile = "";
                this.vertification = "";
                this.password = "";
                this.code = "";
                this.pid = "";
            },
            // 获取图片验证
            getImgCode() {
                let num = Math.random();
                this.captchaToken = Math.ceil(Math.random() * 10000000);
                this.ImgCodeSrc = `${this.baseUrl}/appapi/Captcha/index?t=${num}&token=${this.captchaToken}`;
            },
            // 获取验证码
            getCode() {
                if (this.codeFlag) {
                    return;
                }
                if (!this.mobile) {
                    this.$toast("请输入手机号或邮箱");
                    return;
                }
                if (!this.vertification) {
                    this.$toast("请输入图形验证码");
                    return;
                }
                this.codeFlag = true;
                let btn = document.getElementById("getCodeBtn");
                let num = 60;
                let t = setInterval(() => {
                    btn.innerHTML = `${num}秒`;
                    num--;
                    if (num <= 0) {
                        this.codeFlag = false;
                        btn.innerHTML = "获取验证码";
                        clearInterval(t);
                    }
                }, 1000);
                let params = {
                    mobile: this.mobile,
                    vertification: this.vertification,
                    token: this.captchaToken,
                };
                this.ajax.post("appapi/Register/sendSmsRegisterCode", params).then((res) => {
                    if (res.data.code === 1) {
                        this.$toast(res.data.msg);
                    } else {
                        clearInterval(t);
                        this.codeFlag = false;
                        btn.innerHTML = "获取验证码";
                        this.getImgCode();
                    }
                })
            },
            onRegister() {
                if (!this.mobile) {
                    this.$toast("请输入手机号或邮箱");
                    return;
                }
                if (!this.vertification) {
                    this.$toast("请输入图形验证码");
                    return;
                }
                if (!this.code) {
                    this.$toast("请输入验证码");
                    return;
                }

                if (!this.pid) {
                    this.$toast("请输入邀请码");
                    return;
                }
                let parmas = {
                    mobile: this.mobile,
                    pid: this.pid,
                    vertification: this.code,
                    password: this.formNavIndex ? this.password : "",
                    register_type: this.formNavIndex ? "password" : "",
                };
                this.ajax.post("appapi/Register/register", parmas)
                    .then(res => {
                        console.log("res", res);
                        if (res.data.code === 1) {
                            // 储存 token
                            sessionStorage.setItem("token", res.data.data.token);
                            this.$toast(res.data.msg);
                            this.$router.push({path: "/"});
                        } else {
                            this.$toast(res.data.msg);
                        }
                    });
                //this.saveUserInfo(this.userInfo);
            }
        }
    }
</script>

<style lang='scss'>
    .register {
        .wrapper {
            background: url(../../assets/img/login_background.png) no-repeat 0 0;
            background-size: 100%;
            width: 100%;
            padding: 173px 33px 63px;

            &-logo {
                width: 175px;
                height: 175px;
                margin: 0 auto 130px;
            }
        }

        .container {
            box-shadow: 0 6px 40px 0 rgba(56, 109, 65, 0.12);
            border-radius: 20px;
            box-sizing: border-box;
            background: #F8F8F8;

            .formNav {
                display: flex;
                align-items: center;
                justify-content: space-between;
                overflow: hidden;

                li {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 28px 0 10px;
                    font-size: 30px;
                    font-weight: bold;
                    line-height: 67px;
                    border-radius: 20px 20px 0 0;
                    color: rgba(153, 153, 153, 1);
                    background: #F8F8F8;
                }

                .nav-active {
                    background: #fff;
                    color: #26C472;
                }
            }

            .form-item-wrap {
                padding: 0 30px 48px;
                border-radius: 20px;
                background: #fff;
            }

            .phone-icon {
                width: 21px;
                height: 31px;
            }

            .verify-icon {
                width: 23px;
                height: 28px;
            }
        }

        .form-item-btn {
            margin: 30px 0 63px;
        }

        .form-item-extract {
            font-size: 28px;
            color: #666666;
            text-align: right;
            font-weight: bold;
            padding: 20px;
        }
    }
</style>
